// Runtime environment config helper.
// Resolution order:
//   1. window._env_  — staging Docker image's env-config.js
//   2. window.env    — production EC2 nginx's env-config.js
//   3. process.env   — build-time bake-in (.env.{development,staging,production})
//   4. defaultValue
// The two runtime names exist for historical reasons; both deployments
// inject env-config.js into index.html, just under different globals.

export function getEnv(key, defaultValue = '') {
  if (window._env_ && window._env_[key] !== undefined) {
    return window._env_[key];
  }
  if (window.env && window.env[key] !== undefined) {
    return window.env[key];
  }
  if (process.env[key] !== undefined) {
    return process.env[key];
  }
  return defaultValue;
}

// Export all environment variables
export const env = {
  VUE_APP_TITLE: getEnv('VUE_APP_TITLE', 'BML Factory'),
  VUE_APP_SHORT_NAME: getEnv('VUE_APP_SHORT_NAME', 'BML'),
  VUE_APP_ICONS_PATH: getEnv('VUE_APP_ICONS_PATH', './img'),
  VUE_APP_BASE_URL: getEnv('VUE_APP_BASE_URL', 'http://localhost:8080'),
  VUE_APP_AUTHHOST: getEnv('VUE_APP_AUTHHOST', 'http://localhost:8082'),
  VUE_APP_BACKOFFICE_URL: getEnv('VUE_APP_BACKOFFICE_URL', 'http://localhost:8070'),
  VUE_APP_COLOR: getEnv('VUE_APP_COLOR', '#2196F3'),
  VUE_APP_COLOR_PRIMARY: getEnv('VUE_APP_COLOR_PRIMARY', 'blue'),
  VUE_APP_COLOR_SECONDARY: getEnv('VUE_APP_COLOR_SECONDARY', 'grey'),
  VUE_APP_COLOR_ACCENT: getEnv('VUE_APP_COLOR_ACCENT', 'blue'),
  VUE_APP_COLOR_ERROR: getEnv('VUE_APP_COLOR_ERROR', 'red'),
  VUE_APP_COMPANY_NAME: getEnv('VUE_APP_COMPANY_NAME', 'Bergsoe Metals Co., Ltd'),
  VUE_APP_COMPANY_ADDRESS: getEnv('VUE_APP_COMPANY_ADDRESS', '250 Moo 11 Keangkhoi, Saraburi Thailand 18110'),
  VUE_APP_COMPANY_PHONE: getEnv('VUE_APP_COMPANY_PHONE', '036-358-642'),
  VUE_APP_CRYPTR_KEY: getEnv('VUE_APP_CRYPTR_KEY', 'bergsoemetalsltd'),
  VUE_APP_GOOGLE_CLIENT_ID: getEnv('VUE_APP_GOOGLE_CLIENT_ID', '207667194184-dtrcsada2tmf9o83np6rur1d05gf1ff2.apps.googleusercontent.com'),
  VUE_APP_GA_MEASUREMENT_ID: getEnv('VUE_APP_GA_MEASUREMENT_ID', ''),
  VUE_APP_PORT: getEnv('VUE_APP_PORT', '8080'),
  // Build provenance, baked in by the Dockerfile from CI's build args.
  // 'dev' locally, where nothing sets them.
  VUE_APP_BUILD_COMMIT: getEnv('VUE_APP_BUILD_COMMIT', 'dev'),
  VUE_APP_BUILD_BRANCH: getEnv('VUE_APP_BUILD_BRANCH', 'dev'),
  VUE_APP_BUILD_STAGE: getEnv('VUE_APP_BUILD_STAGE', 'local'),
  VUE_APP_BUILD_TIME: getEnv('VUE_APP_BUILD_TIME', '')
};

export default env;
